<template>
  <!-- 文档列表 -->
  <div class="page_padding">
    <div>
      <div class="head">
        <!-- 筛选 -->
        <ul class="screening_box">
          <li>
            <el-input
              placeholder="请输入批次号"
              v-model="searchForm.batchId"
              @change="search"
              clearable
            >
            </el-input>
          </li>
          <li>
            <el-select
              v-model="searchForm.type"
              clearable
              placeholder="请选择下载状态"
            >
              <el-option
                v-for="key in Object.keys(status)"
                :key="key"
                :label="status[key].status"
                :value="key"
              >
              </el-option>
            </el-select>
          </li>
        </ul>
      </div>
      <!-- 列表 -->
      <div id="table_list">
        <el-table
          ref="table"
          v-load="loading"
          :data="tableData"
          style="width: 100%"
          :height="table_height"
        >
          <el-table-column prop="batchId" label="批次号"> </el-table-column>
          <el-table-column label="类型">
            <template slot-scope="scope">
              {{ scope.row.excleType == 1 ? "图片" : "视频" }}
            </template>
          </el-table-column>
          <el-table-column label="状态">
            <template slot-scope="scope">
              <span :style="'color:' + status[scope.row.type].color">{{
                status[scope.row.type].status
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="addOn" label="创建时间"> </el-table-column>
          <el-table-column label="操作" width="90">
            <template slot-scope="scope">
              <a :href="'/excel/dowLoad/' + scope.row.id">下载</a>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!-- 分页器 -->
      <div class="paging_box">
        <span class="total">共{{ total }}条</span>
        <span class="perPage_num">本页{{ tableData.length }}条</span>
        <el-pagination
          layout="prev, pager, next"
          :current-page="page"
          :page-size="pageSize"
          :total="total"
          @current-change="changePage"
        >
        </el-pagination>
      </div>
    </div>

    <!-- 导入弹窗 -->
    <upLoad
      title="导入视频Excel"
      v-model="dialogVisible"
      :url="$api.upLoadVideo"
      @upLoadSuccess="upLoadSuccess"
    />
  </div>
</template>

<script>
import upLoad from "../components/upload.vue";
import exportBtn from "../components/exportBtn.vue";

export default {
  components: { upLoad, exportBtn },
  data() {
    return {
      dialogVisible: false,
      loading: false,
      page: 1,
      pageSize: 20,
      total: 0,
      tableData: [],
      table_height: 400,
      // 搜索数据
      searchForm: {
        batchId: "",
        type: ""
      },
      status: {
        0: { color: "#F56C6C", status: "不支持下载" },
        1: { color: "#67C23A", status: "可下载" }
      },
      file: {}
    };
  },
  computed: {},
  watch: {
    "searchForm.type": {
      deep: true,
      handler() {
        this.search();
      }
    }
  },
  mounted() {
    this.getList();
    this.$nextTick(() => {
      this.changeTableHeight("init");
    });

    window.onresize = () => {
      this.changeTableHeight("onresize");
    };
  },
  methods: {
    // 获取列表
    getList() {
      this.loading = true;
      this.$refs.table.bodyWrapper.scrollTop = 0;
      let data = JSON.parse(JSON.stringify(this.searchForm));
      data.pageSize = this.pageSize;
      data.pageIndex = this.page;
      this.$http({
        url: this.$api.doc_list,
        data,
        baseUrl: true
      }).then(res => {
        this.loading = false;
        if (res.code == 0) {
          this.total = res.data.total;
          this.tableData = res.data.list;
        }
      });
    },
    // 点击导入Excel
    postExcel() {
      this.dialogVisible = true;
    },
    // 导入完成
    upLoadSuccess() {
      this.searchForm.batchId = "";
      this.searchForm.type = "";
      this.search();
    },
    // 搜索
    search() {
      this.page = 1;
      this.getList();
    },
    // 翻页
    changePage(e) {
      this.page = e;
      this.getList();
    },
    // 计算表格高度
    changeTableHeight(type) {
      let height = document.getElementById("table_list").offsetHeight;
      if (type == "onresize" && this.table_height == height) return;
      this.table_height = height;
      if (this.table_height < 550) {
        this.dialog_top = "5vh";
      } else {
        this.dialog_top = "15vh";
      }
    }
  }
};
</script>

<style></style>
<style lang="less" scoped>
.head {
  padding-right: 0px;
}

.screening_box {
  > li {
    display: flex;
    align-items: center;
    white-space: nowrap;
    font-size: 13px;
    margin-right: 10px;
    &:nth-last-child(1) {
      margin-right: 0px;
    }
  }
}
/deep/.screening_box {
  .el-input__inner {
    margin-left: 0;
  }
}
.table_list {
  border-radius: 4px;
  overflow: hidden;
}
.text_box {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  cursor: pointer;
  &:hover {
    color: #525f7f;
    font-weight: bold;
  }
}
.url_box {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
}

.paging_box {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/pages/identify/views/docList.vue